<template>
  <div class="weizhi">
    <img class="img" src="../assets/three.png" alt="">
   
  </div>
</template>
<script>
    export default {
        name: 'Products',
        data () {
            return {

            }
        }
    }
</script>

<style scoped>
  *{
    box-sizing: border-box;
    margin:0;
    padding:0;
  }
  .img{
    /* height:500px; */
    width:100%;
  }
      .weizhi{
        position: relative;;
    }
    .postion{
position: absolute;
bottom:5%;
right: 39%;
width: 23%;
    }
</style>